import React from 'react'

import { Icon } from '@fourthwall/components'
import { TickIcon } from '@fourthwall/icons'

import * as S from './KitConnected.styled'

export const KitConnected = () => {
  return (
    <S.Container>
      <S.Title>
        <Icon component={TickIcon} width={24} height={24} />
        <div>Successfully Connected to Kit</div>
      </S.Title>

      <S.Description>
        Your Fourthwall shop is now connected to Kit. You can now sync your supporter data and
        create powerful email marketing campaigns to engage with your community.
      </S.Description>

      {/* <S.Footer>
        Need help getting started? Visit our{' '}
        <ButtonClean label="Help Center" href={routing.external.helpCenter.kit} target="_blank" />{' '}
        for detailed guides and best practices.
      </S.Footer> */}
    </S.Container>
  )
}
